import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import styled from '@emotion/styled';

import { TableComponent } from '../../components/TableCom';
import { ModalProvider } from '../../context/ModalContext';
import { TableRefreshProvider } from '../../context/TableRefreshContext';
import useClearerList from '../../hooks/clearer/useClearerList';
import { PACKAGE_WITHIN } from '../../routes/routeConstants';
import Summary from '../../sections/dashboard/home/Summary';

const Home = () => {
  const navigate = useNavigate();
  const { getClearerList } = useClearerList();

  useEffect(() => {
    getClearerList();
    // eslint-disable-next-line
  }, []);

  return (
    <HomeWrapper>
      <Summary />
      <TableRefreshProvider>
        <ModalProvider>
          <Container>
            <TableComponent
              // rigthRevealComponent={CargoDetails}
              cellNavigation={(data) => {
                console.log('£@@£@£-data--£@£@£', data);
                navigate(
                  `${PACKAGE_WITHIN}/${data.airWayBillNumber}/${data.id}`
                );
              }}
              tableBaseUrl="general-service/v1/cargos"
              tableLabel="Home - Inbound waybill"
              tableHeader={[
                'airWayBillNumber',
                'numberOfItems',
                'arrivalDate',
                'assignedClearanceAgentName',
                'arrivalTerminal',
                'status',
              ]}
              mappingData={{
                airWayBillNumber: 'Airwaybill No',
                numberOfItems: 'No of Items',
                arrivalDate: 'Arrival Date',
                assignedClearanceAgentName: 'Clearer',
                arrivalTerminal: 'Arrival Terminal',
                status: 'Clearer Status',
              }}
            />
          </Container>
        </ModalProvider>
      </TableRefreshProvider>
    </HomeWrapper>
  );
};

export default Home;

const HomeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
